import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { audioApi } from "./api";

const AudioAccessContext = createContext(null);

const DEFAULTS = {
  audio_mode: "FREE",
  subscription_price: 50,
  currency: "INR",
  plan_name: "Single Plan",
  plan_description: "Unlimited access to Bala Basava Audio Comics",
  launch_offer_enabled: true,
  launch_offer_text: "FREE FOR A LIMITED PERIOD",
  cta_primary: "Browse Audio Library",
  cta_secondary: "Subscribe to Listen",
};

export function AudioAccessProvider({ children }) {
  const [cfg, setCfg] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await audioApi.get("/access-mode");
      setCfg({ ...DEFAULTS, ...(r.data || {}) });
    } catch {
      setCfg(DEFAULTS);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = {
    ...cfg,
    loaded,
    is_free: cfg.audio_mode === "FREE",
    currency_symbol: cfg.currency === "INR" ? "₹" : cfg.currency,
    price_label: cfg.audio_mode === "FREE"
      ? "FREE"
      : `${cfg.currency === "INR" ? "₹" : cfg.currency}${cfg.subscription_price}/mo`,
    refresh,
  };

  return (
    <AudioAccessContext.Provider value={value}>
      {children}
    </AudioAccessContext.Provider>
  );
}

export function useAudioAccess() {
  const v = useContext(AudioAccessContext);
  if (!v) throw new Error("useAudioAccess must be used within AudioAccessProvider");
  return v;
}
